import "./PromotorFormModal.css";
import { BaseSmallModalFormComponent } from "../../../shared/components/modal/BaseSmallModalFormComponent";
import { PromotorResponse } from "../../../shared/response/terceros/PromotorResponse";
import { PromotorPayload } from "../../../shared/services/api/payload/terceros/PromotorPayload";
import { PromotorSaveService } from "../../services/terceros/PromotorSaveService";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";

const TIPOS = [
  { value: "interno", label: "Interno" },
  { value: "externo", label: "Externo" },
  { value: "distribuidor", label: "Distribuidor" },
];

export class PromotorFormModal extends BaseSmallModalFormComponent<
  PromotorResponse,
  PromotorPayload,
  PromotorSaveService
> {
  private _nombreInput!: HTMLInputElement;
  private _emailInput!: HTMLInputElement;
  private _telefonoInput!: HTMLInputElement;
  private _tipoSelect!: HTMLSelectElement;
  private _activoCheck!: HTMLInputElement;

  constructor(
    private readonly _onSaved: (item: PromotorResponse) => void,
    private readonly _item?: PromotorResponse,
  ) {
    super(new PromotorSaveService());
  }

  protected get title(): string {
    return this._item ? "Editar promotor" : "Nuevo promotor";
  }

  protected renderBody(): string {
    const nombre   = this._item?.nombre   ?? "";
    const email    = this._item?.email    ?? "";
    const telefono = this._item?.telefono ?? "";
    const tipo     = this._item?.tipo     ?? "";
    const activo   = this._item?.isActivo ?? true;

    return `
      <div class="pm-form-fields">
        <div class="pm-form-group">
          <label class="pm-form-label" for="pm-f-nombre">
            Nombre <span class="pm-required">*</span>
          </label>
          <input
            id="pm-f-nombre"
            class="sx-input"
            type="text"
            placeholder="Nombre del promotor"
            value="${nombre}"
            maxlength="250"
          />
        </div>
        <div class="pm-form-group">
          <label class="pm-form-label" for="pm-f-email">Email</label>
          <input
            id="pm-f-email"
            class="sx-input"
            type="email"
            placeholder="correo@ejemplo.com"
            value="${email}"
            maxlength="250"
          />
        </div>
        <div class="pm-form-group">
          <label class="pm-form-label" for="pm-f-telefono">Teléfono</label>
          <input
            id="pm-f-telefono"
            class="sx-input"
            type="tel"
            placeholder="+57 300 000 0000"
            value="${telefono}"
            maxlength="30"
          />
        </div>
        <div class="pm-form-group">
          <label class="pm-form-label" for="pm-f-tipo">Tipo</label>
          <select id="pm-f-tipo" class="sx-input">
            <option value="">Seleccionar tipo...</option>
            ${TIPOS.map((t) => `<option value="${t.value}" ${t.value === tipo ? "selected" : ""}>${t.label}</option>`).join("")}
          </select>
        </div>
        <div class="pm-form-group pm-check-row">
          <label class="pm-check-label">
            <input type="checkbox" id="pm-f-activo" ${activo ? "checked" : ""} />
            <span>Activo</span>
          </label>
        </div>
      </div>
    `;
  }

  protected override onAfterRender(el: HTMLDivElement): void {
    this._nombreInput   = el.querySelector<HTMLInputElement>("#pm-f-nombre")!;
    this._emailInput    = el.querySelector<HTMLInputElement>("#pm-f-email")!;
    this._telefonoInput = el.querySelector<HTMLInputElement>("#pm-f-telefono")!;
    this._tipoSelect    = el.querySelector<HTMLSelectElement>("#pm-f-tipo")!;
    this._activoCheck   = el.querySelector<HTMLInputElement>("#pm-f-activo")!;

    this._nombreInput.addEventListener("input", () => this._validate());
    this._validate();
  }

  protected buildPayload(): PromotorPayload {
    return {
      id:       this._item?.id ?? null,
      nombre:   this._nombreInput.value.trim(),
      email:    this._emailInput.value.trim(),
      telefono: this._telefonoInput.value.trim(),
      tipo:     this._tipoSelect.value || null,
      isActivo: this._activoCheck.checked,
    };
  }

  /** Avisa si la ficha se enlazó a un usuario que ya existía (Nitrofert) y cierra el formulario. */
  protected override onSaved(item: PromotorResponse): void {
    if (item.enlazadoAUsuarioExistente) {
      errorMessageComponent.addSuccess(
        "Ficha enlazada",
        "Ya había un usuario con ese correo: la ficha de promotor quedó enlazada a ese usuario y recibió el rol comercial.",
      );
    }
    this._onSaved(item);
    this.dispose();
  }

  private _validate(): void {
    this.setSaveDisabled(this._nombreInput.value.trim().length === 0);
  }
}
